export default __webpack_public_path__ + "static/media/bgpattern.d101906f.png";